// Azure Storage service for fetching showcase apps

const STORAGE_ACCOUNT = process.env.REACT_APP_STORAGE_ACCOUNT || 'astenainternalappstorage';
const CONTAINER_NAME = process.env.REACT_APP_CONTAINER_NAME || 'astenaapps';
const SAS_TOKEN = process.env.REACT_APP_SAS_TOKEN || 'sp=r&st=2026-02-13T18:49:53Z&se=2036-02-14T03:04:53Z&spr=https&sv=2024-11-04&sr=c&sig=gmoNlf8yJLwmvhumSDDef0rgiwYL5wR8cbV0jHkvsC8%3D';
const BASE_URL = `https://${STORAGE_ACCOUNT}.blob.core.windows.net/${CONTAINER_NAME}`;

/**
 * Transforms local config to add Azure Storage URLs
 * 
 * Card image is always: {name}/card.png
 * Mockups will be fetched dynamically from the folder
 */
export const transformAppsConfig = (config) => {
  const sasParam = SAS_TOKEN ? `?${SAS_TOKEN}` : '';
  
  const apps = config.apps.map((app, index) => ({
    id: `app${index + 1}`,
    name: app.name,
    title: app.title,
    short: app.short,
    category: app.category,
    status: app.status,
    folder: app.name,
    image: `${BASE_URL}/${app.name}/card.png${sasParam}`,
    link: '#'
  }));
  
  return apps;
};

/**
 * Lists all PNG files in a folder (excluding card.png)
 * Returns array of full URLs to mockup images
 */
export const listMockupsInFolder = async (folderName) => {
  const sasParam = SAS_TOKEN ? `?${SAS_TOKEN}&` : '?';
  const url = `https://${STORAGE_ACCOUNT}.blob.core.windows.net/${CONTAINER_NAME}${sasParam}restype=container&comp=list&prefix=${folderName}/`;
  
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to list blobs: ${response.statusText}`);
    }
    
    const xmlText = await response.text();
    
    // Parse XML to extract PNG files
    const blobMatches = xmlText.matchAll(/<Blob><Name>([^<]+)<\/Name>/g);
    const mockupUrls = [];
    
    for (const match of blobMatches) {
      const blobPath = match[1];
      const fileName = blobPath.split('/').pop();
      
      // Include only PNG files that are not card.png or card_up.png
      if (fileName.toLowerCase().endsWith('.png') && 
          fileName.toLowerCase() !== 'card.png' && 
          fileName.toLowerCase() !== 'card_up.png') {
        const sasToken = SAS_TOKEN ? `?${SAS_TOKEN}` : '';
        mockupUrls.push(`${BASE_URL}/${blobPath}${sasToken}`);
      }
    }
    
    // Sort by filename
    mockupUrls.sort();
    
    return mockupUrls;
  } catch (error) {
    console.error('Error listing mockups:', error);
    return [];
  }
};

/**
 * Fetches mockup images for a specific app
 */
export const fetchAppMockups = async (appFolder, mockupFiles) => {
  try {
    const sasParam = SAS_TOKEN ? `?${SAS_TOKEN}` : '';
    const mockupUrls = mockupFiles.map(file => `${BASE_URL}/${appFolder}/${file}${sasParam}`);
    return mockupUrls;
  } catch (error) {
    console.error('Error fetching mockups:', error);
    throw error;
  }
};

/**
 * Constructs the URL for an app's card image
 */
export const getCardImageUrl = (appFolder, imageName) => {
  const sasParam = SAS_TOKEN ? `?${SAS_TOKEN}` : '';
  return `${BASE_URL}/${appFolder}/${imageName}${sasParam}`;
};

const azureStorageService = {
  transformAppsConfig,
  listMockupsInFolder,
  fetchAppMockups,
  getCardImageUrl
};

export default azureStorageService;
